import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaAmazon } from 'react-icons/fa';

/* ── Brand SVG icons (Arcticons style) for platforms not in react-icons ── */
const MyntraIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20" aria-label="Myntra">
        <ellipse cx="28.311" cy="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" rx="13.871" ry="4.22" transform="rotate(-68.92 28.311 24)"/>
        <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M32.727 24.215q.227.647.48 1.303c2.756 7.148 6.752 12.263 8.927 11.425s1.703-7.312-1.052-14.46s-6.752-12.264-8.927-11.426"/>
        <ellipse cx="10.856" cy="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" rx="13.871" ry="4.22" transform="rotate(-68.92 10.856 24)"/>
        <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M15.272 24.215q.227.647.48 1.303c2.06 5.343 4.812 9.55 6.98 10.984M24 23.49q-.18-.501-.374-1.008c-2.756-7.148-6.752-12.263-8.927-11.425"/>
    </svg>
);

const MeeshoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20" aria-label="Meesho">
        <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            d="M18.9 32.4c-.3.6-.9 1-1.6 1c-1 0-1.9-.9-1.9-1.9v-1.2c0-1.1.9-1.9 1.9-1.9s1.8.8 1.9 1.9v.7h-3.8m9.6 1.4c-.3.6-.9 1-1.6 1c-1 0-1.9-.9-1.9-1.9v-1.2c0-1.1.8-1.9 1.9-1.9s1.9.8 1.9 1.9v.8h-3.8m6.3 1.8c.4.3 1 .4 1.5.4h.4c.7 0 1.2-.5 1.3-1.2c0-.7-.5-1.2-1.2-1.3q0 0 0 0h-.9c-.7 0-1.2-.5-1.3-1.2c0-.7.5-1.2 1.2-1.3q0 0 0 0h.4c.9 0 1.2.1 1.5.4m2.6-3v7.6m0-3.1c0-1 .9-1.9 1.9-1.9h0c1 0 1.9.9 1.9 1.9v3.1m4.2 0c-1 0-1.9-.9-1.9-1.9v-1.2c0-1.1.8-1.9 1.9-1.9c1 0 1.9.8 1.9 1.9v1.3c0 1-.8 1.8-1.9 1.8m-32.5 6c.3 1.2 1.4 2 2.6 2h25.2c1.2 0 2.3-.8 2.6-2m4.2-15.5c.4-1.6-.5-3.2-2.1-3.6c-.3-.1-.5-.2-.8-.2H33L25.6 7.7c-.5-.9-1.7-1.3-2.6-.7c-.3.2-.6.4-.7.7L14.9 20H7.5c-1.6 0-3 1.3-3 3c0 .3 0 .5.1.8M24 12.4l4.5 7.6h-9.1zM5.5 30.2c0-1.1.9-1.9 1.9-1.9h0c1.1 0 1.9.9 1.9 1.9v3.1m-3.8-5v5.1m3.8-3.2c0-1.1.9-1.9 1.9-1.9h0c1.1 0 1.9.9 1.9 1.9v3.1"/>
    </svg>
);

const NykaaIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20" aria-label="Nykaa">
        <circle cx="24" cy="24" r="21.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="m11 35.99l12-23.98v23.98l12-24M32 32h2.6m-2.604 4v-8h4"/>
    </svg>
);

function Footer() {
    const socials = [
        { href: "https://www.instagram.com/pentadeco?igsh=eXUzajJ6aDFlZmJy", icon: <FaInstagram />, label: "Instagram" },
        { href: "https://www.facebook.com/share/19Ybv3kWMc/", icon: <FaFacebookF />, label: "Facebook" },
        { href: "https://www.amazon.in/stores/PENTADECO/page/5CBF87B7-1BD3-4475-B3A1-1CF4DF594BAD?lp_asin=B0CR3P8MVX&ref_=cm_sw_r_apann_ast_store_XSQVQMQDQR4670Z6PQN9&dplnk=Y&dplnkId=46cad73e-5796-4ef9-8a50-5fe95e2a184b", icon: <FaAmazon />, label: "Amazon" },
        { href: "https://www.myntra.com/pentadeco?p=1", icon: <MyntraIcon />, label: "Myntra" },
        { href: "https://share.google/9KUjVxdWXHUrgIZZW", icon: <MeeshoIcon />, label: "Meesho" },
        { href: "https://www.nykaa.com/brands/pentadeco/c/58333", icon: <NykaaIcon />, label: "Nykaa" },
    ];

    return (
        <footer className="footer-main pt-5 pb-3">
            <div className="container">
                <div className="row g-4">

                    {/* Brand */}
                    <div className="col-md-3 col-sm-6">
                        <img src="/assets/penta-logo.png" alt="Pentadeco" className="footer-logo mb-3" />
                        <p className="footer-text mb-1">
                            <i className="fas fa-envelope me-2 footer-icon"></i>
                            pentadeco@gmail.com
                        </p>
                        <p className="footer-text mb-1">
                            <i className="fas fa-phone me-2 footer-icon"></i>
                            +91 77384 94171
                        </p>
                        <p className="footer-text mb-3">
                            <i className="fas fa-phone me-2 footer-icon"></i>
                            +91 84335 51012
                        </p>
                        <div className="d-flex gap-2 footer-socials flex-wrap">
                            {socials.map(({ href, icon, label }) => (
                                <a key={label} href={href} target="_blank" rel="noreferrer" className="footer-social-link" title={label}>
                                    {icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="col-md-2 col-sm-6">
                        <h6 className="footer-heading mb-3">QUICK LINKS</h6>
                        <ul className="list-unstyled footer-links">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/product">Products</Link></li>
                            <li><Link to="/cart">Cart</Link></li>
                            <li><Link to="/orders">Orders</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                        </ul>
                    </div>

                    {/* Quick Shop */}
                    <div className="col-md-2 col-sm-6">
                        <h6 className="footer-heading mb-3">SHOP BY</h6>
                        <ul className="list-unstyled footer-links">
                            <li><Link to="/product?category=mug">Mugs</Link></li>
                            <li><Link to="/product?category=water+bottle">Water Bottles</Link></li>
                            <li><Link to="/product?category=tumblers">Tumblers</Link></li>
                            <li><Link to="/product?category=mouse+pad">Mouse Pads</Link></li>
                            <li><Link to="/product?category=wall+decor">Wall Decor</Link></li>
                        </ul>
                    </div>

                    {/* Customer Services */}
                    <div className="col-md-2 col-sm-6">
                        <h6 className="footer-heading mb-3">POLICIES</h6>
                        <ul className="list-unstyled footer-links">
                            <li><Link to="/disclaimer">Disclaimer</Link></li>
                            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/return-and-refund-policy">Return & Refund</Link></li>
                        </ul>
                    </div>

                    {/* Address */}
                    <div className="col-md-3 col-sm-6">
                        <h6 className="footer-heading mb-3">ADDRESS</h6>
                        <p className="footer-text">
                            <i className="fas fa-map-marker-alt me-2 footer-icon"></i>
                            Kalyan, Kongaon, Maharashtra 421311
                        </p>
                        <div className="footer-badge mt-3 d-flex align-items-center gap-2">
                            <img src="/assets/money.png" alt="COD" width={28} />
                            <span className="footer-text">Cash On Delivery Available</span>
                        </div>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="footer-bottom mt-5 pt-3 d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                    <p className="mb-0 footer-copy">&copy; 2025 Pentadeco. All Rights Reserved.</p>
                    <div className="d-flex align-items-center gap-2 flex-wrap justify-content-center">
                        <span className="footer-copy me-1">Secure payments:</span>
                        <div className="payment-icons d-flex align-items-center gap-1">
                            <img src="https://img.icons8.com/color/32/visa.png" alt="Visa" />
                            <img src="https://img.icons8.com/color/32/mastercard.png" alt="MasterCard" />
                            <img src="https://img.icons8.com/color/32/amex.png" alt="Amex" />
                            <img src="https://img.icons8.com/color/32/paypal.png" alt="PayPal" />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
